<template>
  <div class="stories">
    <div class="stories__header">hrdesk Developer Stories</div>
    <nav class="stories__nav">
      <div>
        <router-link to="/library">INPUT</router-link>
      </div>
      <div>
        <router-link to="/search">HEADER SEARCH</router-link>
      </div>
      <div>
        <router-link to="/white-loading">WHITE BUTTON LOADER</router-link>
      </div>
      <div>
        <router-link to="/blue-loading">BLUE BUTTON LOADER</router-link>
      </div>
      <div>
        <router-link to="/input-loading">INPUT FIELD LOADER</router-link>
      </div>
      <div>
        <router-link to="/page-loading">PAGE LOADER</router-link>
      </div>
      <div>
        <router-link to="/dashboard">GO BACK</router-link>
      </div>
    </nav>
    <section class="stories__components">
      <router-view></router-view>
    </section>
  </div>
</template>

<script>
export default {
  name: "Library",
};
</script>

<style lang="scss" scoped>
.stories {
  overflow: hidden;
}

.stories__header {
  text-align: center;
  padding: 20px 0;
  font-size: 1.302vw;
}

.stories__nav {
  float: left;
  width: 200px;
  background-color: #fbfafa;

  > div {
    padding: 10px 0 10px 20px;
    font-size: 0.833vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.22;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    border: 1px solid #ccc;
  }
}

.stories__components {
  float: left;
  overflow: hidden;
  width: calc(100% - 200px);
  padding-top: 50px;
  padding-left: 20px;
  border-top: 1px solid #ccc;
}
</style>
